<template>
  <div class="row" ref="get2faCode">
    <div class="col-12">
      <div class="form-group">
        <div class="row align-items-center">
          <div class="col-8">
            <k-input
              id="verificationCode"
              :label="'Verification Code'"
              placeholder="'Verification Code'"
              v-model="verificationCode"
              :disabled="this.codeInputDisabled"
              class="mobile-text"
            />
          </div>
          <div class="col-4">
            <k-button
              class="btn btn-success btn-sm get-code mb-0 w-100 mobile-button"
              type="button"
              @click="getCode"
            >Get code</k-button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5">
      <k-button
        :class="'btn btn-lg btn-secondary w-100'"
        type="button"
        @click="submitCode()"
      >Submit</k-button>
    </div>
    <div class="mt-1">
      <k-button
        :class="'btn btn-lg btn-outline-primary w-100'"
        type="button"
        @click="selectTwoFactor"
        v-if="this.add2FA"
      >Back</k-button>
      <k-button
        :class="'btn btn-lg btn-outline-primary w-100'"
        type="button"
        @click="backToProtocolOptions"
        v-else
      >Back</k-button>
    </div>
    <div class="mt-2"></div>
  </div>
</template>

<script>
import AuthService from "../services/auth-service";
import store from "../store";
import { useToast } from "vue-toastification";
const toast = useToast();

export default({
  name: "get-2fa-code",
  props: {
    email: String,
    add2FA: Boolean,
    method: String,
    verificationMethod: String
  },
  data() {
    return {
      verificationCode: "",
      codeInputDisabled: true
    }
  },
  methods: {
    async getCode() {
      if (this.add2FA) {
        await AuthService.Send2FAChallenge(this.email, this.verificationMethod, store.getters.twoFactorGUID)
          .then((response) => {
            if (response.data) {
              this.codeInputDisabled = false;
              toast.clear();
              toast.success("Code sent successfully");
            } else {
              this.showAlertGetCode();
            }
        }).catch((err) => {
          this.showAlertGetCode(err);
        });
      } else {
        await AuthService.Send2FAChallengeByID(store.getters.userID, this.verificationMethod, store.getters.twoFactorGUID)
          .then((response) => {
            if (response.data) {
              this.codeInputDisabled = false;
              toast.clear();
              toast.success("Code sent successfully");
            } else {
              this.showAlertGetCode();
            }
        }).catch((err) => {
          this.showAlertGetCode(err);
        });
      }
    },
    async submitCode() {
      if (this.verificationCode) {
        if (this.add2FA) {
          this.$parent.setTwoFactorCode(this.verificationCode);
          this.$parent.login();
        } else {
          this.removeTwoFactorMethod(store.getters.userID, this.method, this.verificationCode);
        }
      } else {
        this.showAlertSubmitCode();
      }
    },
    showAlertGetCode(error) {
      toast.clear();
      if (error && error.message === "Session has expired. Log in again to continue.") {
        toast.error(error.message);
        setTimeout(() => {
          location.reload();
        }, 1000);
      } else {
        toast.error("Error sending code. Please try again.");
      }
    },
    showAlertSubmitCode() {
      toast.clear();
      toast.error("Code is incorrect.");
    },
    showAlertRemove() {
      toast.clear();
      toast.error("Error removing Two Factor method. Please try again.");
    },
    async removeTwoFactorMethod(userID, method, code) {
      await AuthService.RemoveTwoFactorMethod(userID, method, code)
        .then((response) => {
          if (response.data) {
            toast.clear();
            toast.success("Two factor method removed.");
            this.$parent.click2fa();
          } else {
            this.showAlertSubmitCode()
          }
      }).catch(this.showAlertRemove);
    },
    backToProtocolOptions() {
      this.$parent.backToProtocolOptions();
    },
    selectTwoFactor() {
      this.$parent.selectTwoFactor();
    }
  }
})
</script>

<style lang="scss" restr>
  .get-code {
    float: left;
    margin-bottom: 20px;
  }
</style>
